const COMPONENTS = {
  QUOTES: "misc.quote",
  STATE: "misc.stat",
};
export default COMPONENTS;
